import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'com-form-item',
  templateUrl: './form-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormItemComponent {}
